import { post } from 'aws-amplify/api';
import { PRESCRIPTSURE } from '../constants/api-endpoints';
import { getSessionToken } from './service-config';
const apiNamePath = PRESCRIPTSURE.ANALYTICS_API;

const drugSearchAnalyticService = {
  async getDrugSearchStats({ dateRange, userRole, organization }) {
    const sessionToken = await getSessionToken();

    const getDrugSearchStatsOperation = post({
      apiName: apiNamePath,
      path: '/drug_activity',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          query_path: 'drug_stats',
          date_range: dateRange,
          user_role: userRole,
          organization: organization,
        },
      },
    });

    const getDrugSearchStatsResults = (
      await getDrugSearchStatsOperation.response
    ).body.json();

    return getDrugSearchStatsResults;
  },

  async getMostSearchedDrugs({ dateRange, userRole, organization }) {
    const sessionToken = await getSessionToken();

    const getMostSearchedDrugsOperation = post({
      apiName: apiNamePath,
      path: '/drug_activity',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          query_path: 'top_10_most_searched_drugs',
          date_range: dateRange,
          user_role: userRole,
          organization: organization,
        },
      },
    });

    const getMostSearchedDrugsResults = (
      await getMostSearchedDrugsOperation.response
    ).body.json();

    return getMostSearchedDrugsResults;
  },

  async getMostActiveDrugSearchUsers({ dateRange, userRole, organization }) {
    const sessionToken = await getSessionToken();

    const getMostActiveDrugSearchUsersOperation = post({
      apiName: apiNamePath,
      path: '/drug_activity',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          query_path: 'most_active_drug_search_users',
          date_range: dateRange,
          user_role: userRole,
          organization: organization,
        },
      },
    });

    const getMostActiveDrugSearchUsersResults = (
      await getMostActiveDrugSearchUsersOperation.response
    ).body.json();

    return getMostActiveDrugSearchUsersResults;
  },

  async getDrugSearchToCoverageInsights({ dateRange, userRole, organization }) {
    const sessionToken = await getSessionToken();

    const getDrugSearchToCoverageInsightsOperation = post({
      apiName: apiNamePath,
      path: '/drug_activity',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          query_path: 'get_drug_coverage_stats',
          date_range: dateRange,
          user_role: userRole,
          organization: organization,
        },
      },
    });

    const getDrugSearchToCoverageInsightsResults = (
      await getDrugSearchToCoverageInsightsOperation.response
    ).body.json();

    return getDrugSearchToCoverageInsightsResults;
  },
};

export default drugSearchAnalyticService;
